
<div class="proposal-dialog">

  <div class="content">
    <!-- {{data | json}}    -->
    @if (proposal.id===0 && !isModification && !isCompletion) {
      <h1> Créer proposition  </h1>
    }
    @if (proposal.id > 0 && !isModification && !isCompletion) {
      <h1> Editer proposition  </h1>
    }
    @if (isModification && !isCompletion) {
      <h1> Modifier proposition</h1>
    }
    @if (isCompletion) {
      <h1> Compléter proposition</h1>
    }

    <form #proposalForm="ngForm" class="proposal-form">

      @if (! isModification && !isCompletion) {
        <mat-form-field>
          <mat-label>Date visite proposée</mat-label>
          <input required matInput [matDatepicker]="picker" name ="appointmentDate" [(ngModel)]="proposal.appointmentDate">
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      }

      @if (! isModification && !isCompletion) {
        <mat-form-field>
          <mat-label>Offre</mat-label>
          <input type="number" required matInput="" name ="proposedPrice" step="1000" placeholder="Offre"  [(ngModel)]="proposal.proposedPrice.amount" >
        </mat-form-field>
      }

      @if (! isModification && !isCompletion) {
        <mat-form-field>
          <mat-label >Commentaire</mat-label>
          <textarea matInput type="text" name ="comment" placeholder=""  [(ngModel)]="proposal.comment" ></textarea>
        </mat-form-field>
      }

      @if (isModification && !isCompletion) {
        <mat-form-field>
          <mat-label>Date alternative</mat-label>
          <input required matInput [matDatepicker]="picker1" name ="rescheduleDate" [(ngModel)]="proposal.modification!.appointmentDate">
          <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      }

      @if (isModification && !isCompletion) {
        <mat-form-field>
          <mat-label>Offre</mat-label>
          <input type="number" required matInput="" name ="proposedPrice1" step="1000" placeholder="Offre"  [(ngModel)]="proposal.modification!.proposedPrice.amount" >
        </mat-form-field>
      }

      @if (isModification && !isCompletion) {
        <mat-form-field>
          <mat-label >Commentaire</mat-label>
          <textarea matInput type="text" name ="comment1" placeholder=""  [(ngModel)]="proposal.modification!.comment" ></textarea>
        </mat-form-field>
      }



      @if (isCompletion) {
        <mat-form-field>
          <mat-label>Date vente</mat-label>
          <input [required] = false matInput [matDatepicker]="picker2" name ="appointmentDate2" [(ngModel)]="proposal.completedDate">
          <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      }

      @if (isCompletion) {
        <mat-form-field>
          <mat-label>Montant vente</mat-label>
          <input type="number" required matInput="" name ="proposedPrice2" step="1000" placeholder="Offre"  [(ngModel)]="proposal.completedPrice.amount" >
        </mat-form-field>
      }

      @if (isCompletion) {
        <mat-form-field>
          <mat-label >Commentaire vente</mat-label>
          <textarea matInput type="text" name ="comment2" placeholder=""  [(ngModel)]="proposal.completedNotes" ></textarea>
        </mat-form-field>
      }

      <!--
      <mat-form-field *ngIf="!isModification">
        <mat-label>Date visite proposée</mat-label>
        <input required matInput [matDatepicker]="picker" name ="appointmentDate" [(ngModel)]="proposal.appointmentDate">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Offre</mat-label>
        <input type="number" required matInput="" name ="proposedPrice" step="1000" placeholder="Offre"  [(ngModel)]="proposal.proposedPrice.amount" >
      </mat-form-field>

      <mat-form-field>
        <mat-label >Commentaire</mat-label>
        <textarea matInput type="text" name ="comment" placeholder=""  [(ngModel)]="proposal.comment" ></textarea>
      </mat-form-field>

      <mat-form-field *ngIf="isModification">
        <mat-label>Date alternative</mat-label>
        <input required matInput [matDatepicker]="picker1" name ="rescheduleDate" [(ngModel)]="proposal.rescheduleDate">
        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field> <  -->

    </form>

    <div class="action-buttons">
      <button class="simple-button-buy" mat-button [mat-dialog-close]="">Annuler</button>
      <button class="cta-button-buy" [disabled]=!proposalForm.valid mat-button [mat-dialog-close]="proposal" (click)="submitProposal();$event.stopPropagation()">
        Soumettre
      </button>
    </div>
  </div>
</div>